import { MyInfoTabs } from "./MyInfoTabs";

export default MyInfoTabs;
